import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import userSlice from './slices/userSlice';
import productSlice from './slices/productSlice';
import categorySlice from './slices/categorySlice';
import blogSlice from './slices/blogSlice';
import couponSlice from './slices/couponSlice';
import orderSlice from './slices/orderSlice';
import faqSlice from './slices/faqSlice';
import termsSlice from './slices/termsSlice';
import contactSlice from './slices/contactSlice';
import footerSlice from './slices/footerSlice';
import bannerSlice from './slices/bannerSlice';
import dashboardSlice from './slices/dashboardSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    users: userSlice,
    products: productSlice,
    categories: categorySlice,
    blogs: blogSlice,
    coupons: couponSlice,
    orders: orderSlice,
    faqs: faqSlice,
    terms: termsSlice,
    contacts: contactSlice,
    footer: footerSlice,
    banners: bannerSlice,
    dashboard: dashboardSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;